import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/services/global.service';
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { ShareLinkService } from '../../../services/Share-Link/share-link.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';



@Component({
  selector: 'app-live-share-geo-lock',
  templateUrl: './live-share-geo-lock.component.html',
  styleUrls: ['./live-share-geo-lock.component.css']
})
export class LiveShareGeoLockComponent implements OnInit {
  defaultModal = true
  requireCheckbox = false
  isReadOnly: any;
  accessLevel: any;
  selectedUser: any
  userPrivilegeLevel: any
  expiryTime: any
  expiryValue = false
  date: any;
  click: any;
  tinyurl: any
  mapId: any;
  zoom: any
  mapName = 'google-hybrid';
  isEmbed = false;
  userId = +'100'
  RequireCheckBox = false;
  template = ''
  parcelLabel = ''
  checkboxTemplate = ''
  featureLayer = ''
  buffers = ""
  buffersInner = "";
  lat: any
  lon: any
  shareUrl: any
  xmin: any;
  xmax: any;
  ymin: any;
  ymax: any;
  overlayLayer: any;
  overLay: any;
  enabled_overlay: any[] = [];
  basicMode = true
  multipleParcel = false;
  showAnnotations = '';
  selectedPoint = "";
  tcpdEmbed = false
  dataPanelHide = false;
  minZoom: any
  isGeolock: any
  html: any
  logEvent: any
  eventName: any
  eventLogName: any

  constructor(
    private globalService: GlobalService,
    public mapService: MapServiceService,
    public shareLinkService: ShareLinkService,
    private router: Router,
    private sideNavService: SideNavService,
    private route: ActivatedRoute,
    private http: HttpClient,
  ) {
    this.isReadOnly = true
    this.accessLevel = [
      {
        access: 'Public',
        id: 1,
        privilegeLevel: '000'
      },
      {
        access: 'Client',
        id: 2,
        privilegeLevel: '100'
      },
      {
        access: 'Reader',
        id: 3,
        privilegeLevel: '200'
      },
      {
        access: 'Editor',
        id: 4,
        privilegeLevel: '300'
      },
      {
        access: 'Admin',
        id: 5,
        privilegeLevel: '400'
      },
      {
        access: 'Demigod',
        id: 6,
        privilegeLevel: '500'
      },
      {
        access: 'Nobody',
        id: 7,
        privilegeLevel: '999'
      },
      {
        access: 'Deleted',
        id: 8,
        privilegeLevel: '-999'
      },
    ];
    this.selectedUser = this.accessLevel[1];
  }

  ngOnInit(): void {
    // this.html = this.mapService.accessMapApi.map_data.map_data.tool_desc['geolock']
    if (!this.mapService.accessMapApi.map_data.map_data.tool_desc['geolock']) {
      this.html = ''
    } else {
      this.html = this.mapService.accessMapApi.map_data.map_data.tool_desc['geolock']
    }
    this.requireCheckbox = false
    this.isReadOnly = true
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    this.zoom = this.mapService.mapLayer.getView().getZoom() - this.mapService.mapsData.minzoom
    if (!this.mapService.baseLayerName) {
      this.mapService.baseLayerName = this.mapName;
    } else {
      this.mapService.baseLayerName
    }
    const lonLat = this.mapService.mapLayer.getView().getCenter()
    this.lat = lonLat[1];
    this.lon = lonLat[0];


    this.expiryTime = '2';
    this.requireCheckbox = false
    this.isEmbed = false;
    this.route.queryParamMap.subscribe(params => {
      setTimeout(() => {
        this.shareLinkService.shareUrlId = params.get('share');
      }, 1000);

    });
    const originUrl = location.origin;
    const href: any = this.router.url.split('?').shift();
    this.shareUrl = originUrl.concat(href);
    // console.log(this.shareUrl);
    this.userId = +'000'
    // console.log(this.mapService.userAccessLevel)

    this.overlayLayer = this.mapService.getLayersId().toString()
    this.mapService.currentZoom.subscribe(res => {
      this.minZoom = res
    })
  }
  defaultModalType(value: boolean): void {
    this.defaultModal = value;
    this.mapService.defaultModal = value
  }
  requireCheckBoxType(value: boolean) {
    this.requireCheckbox = value;
    this.mapService.reqBox = value
  }
  layerSelect(e: any): void {
    this.selectedUser = e.target.value;
    this.userId = +this.selectedUser
    this.mapService.userUpdate = this.userId
  }
  changeDate(e: any) {
    const dateData = e.target.value;
    this.expiryTime = dateData.toString()
    this.mapService.expiryTime = dateData.toString()
  }
  expiry(e: any): void {
    if (e) {
      this.isReadOnly = false;
      this.expiryValue = true
      this.mapService.checkExpiry = true
    } else {
      this.isReadOnly = true;
      this.date = ''
      this.mapService.checkExpiry = false
    }
  }
  startOver(): void {
    this.requireCheckbox = this.mapService.reqBox
    this.defaultModal = this.mapService.defaultModal
    this.expiryTime = this.mapService.expiryTime
    this.expiryValue = this.mapService.checkExpiry
    this.click = false;
  }
  copy(inputElement: any): void {
    inputElement.select();
    document.execCommand('copy');
    inputElement.background.color = 'red';
    inputElement.setSelectionRange(0, 0);
  }
  getSelectedParcelLabel() {
    const result = {
      "show_parcel_label": this.mapService.showParcelLabel,
      "annotation_parcel_label": this.mapService.annotationLable,
      "is_parcel_layer": this.mapService.isParcelLayer
    }
    const resultData = JSON.stringify(result);
    return resultData;
  }

  createLink(): void {
    const bounds = this.mapService.mapLayer.getView().calculateExtent(this.mapService.mapLayer.getSize())
    for (let i = 0; i < bounds.length; i++) {
      if (i == 0) {
        this.xmin = bounds[i]
      } else if (i == 1) {
        this.xmax = bounds[i]
      } else if (i == 2) {
        this.ymin = bounds[i]
      } else if (i == 3) {
        this.ymax = bounds[i]
      }
    }
    this.zoom = this.mapService.mapLayer.getView().getZoom() - this.mapService.mapsData.minzoom
    this.eventLogName = `${'GeoLock'}+${'Live'}+ ${'Share'}`
    if (!this.mapService.polygonGeometry) {
      this.mapService.polygonGeometry = ''
    }
    if (!this.mapService.pointGeometry) {
      this.mapService.pointGeometry = ''
    }
    if (!this.template) {
      this.template = ''
    }
    if (!this.checkboxTemplate) {
      this.checkboxTemplate = ''
    }
    if (!this.mapService.featureLayerId) {
      this.mapService.featureLayerId = '0'
    }
    if (!this.minZoom) {
      this.minZoom = +10
    }
    if (this.mapService.multiParcelId.length > 1) {
      this.mapService.multiParcel = true
    } else {
      this.mapService.multiParcel = false
    }
    if (!this.mapService.parcel) {
      this.mapService.parcel = ''
    }
    if (!this.overlayLayer) {
      this.overlayLayer = '';
    }
    if (!this.mapService.polygonGeometry) {
      this.mapService.polygonGeometry = ''
    }
    if (!this.mapService.innerBuffer) {
      this.mapService.innerBuffer = ''
    }
    if (!this.shareLinkService.shareUrlId) {
      this.shareLinkService.shareUrlId = ''
    }
    if (this.sideNavService.checkLabel) {
      this.parcelLabel = this.mapService.parcel;
    }
    const body = {
      xmin_bound: this.xmin.toString(),
      xmax_bound: this.xmax.toString(),
      ymin_bound: this.ymin.toString(),
      ymax_bound: this.ymax.toString(),
      zoom: this.zoom.toString(),
      parcel: this.mapService.parcel,
      overlay: this.overlayLayer,
      base_layer: this.mapService.shareCurrentMap,
      feature_layer: this.mapService.featureLayerId,
      point: this.mapService.pointGeometry,
      wkt: this.mapService.polygonGeometry,
      multiple_parcel: this.mapService.multiParcel,
      expiry_time: this.expiryTime,
      buffers: this.mapService.bufferPolygonGeometry,
      buffers_inner: this.mapService.innerBuffer,
      show_annotations: this.mapService.annotationShare.toString() || '',
      selected_point: this.mapService.preSelectedAnnotation || '',
      basic_mode: this.basicMode,
      tcpd_embed: this.tcpdEmbed,
      require_checkbox: this.requireCheckbox,
      checkbox_template: this.checkboxTemplate,
      chosen_privilege_level: +this.selectedUser.privilegeLevel,
      show_legend: true,
      default_modal: this.defaultModal,
      template: this.template,
      parcel_label: this.parcelLabel,
      data_panel_hide: this.dataPanelHide,
      share_url: this.shareUrl,
      is_embed: this.isEmbed,
      minzoom: +this.minZoom,
      expire: false,
      snapshot: false,
      is_geolock: this.isGeolock = true
    };
    this.activityLoging()
    this.shareLinkService.shareLink(this.mapId, this.shareLinkService.shareUrlId, body
    ).subscribe(res => {
      this.globalService.toggleLoader(true);
      setTimeout(() => {
        this.globalService.toggleLoader(false);
        this.click = true;
        this.globalService.toggleLoader(false);
        // this.mapService.shareId = res.id
        this.tinyurl = res.tinyurl
      }, 1000);


    })
  }

  closeLeft() {
    this.mapService.closePanel = true
    this.mapService.setClosePanel(true);
  }
  activityLoging(
  ) {
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapService.mapId.toString(),
          event: "Click",
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: this.eventLogName,
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          point: '',
          wkt: '',
        };
        this.mapService.activityLogs(body).subscribe(() => {
          // console.log('a');
        }, (error: any) => {
          if (error.status == 403) {
            location.reload();
          }
        });
      })
  }
}
